import { clearForumsTracker } from "./localTracker";

const AUTH_USER_KEY = "user";
const AUTH_LEGACY_ID_KEY = "_id";

const isBrowserStorageAvailable = () => {
    try {
        return typeof window !== "undefined" && !!window.localStorage;
    } catch (_e) {
        return false;
    }
};

const migrateSessionUserToLocal = () => {
    if (!isBrowserStorageAvailable()) {
        return null;
    }
    try {
        const fromSession = sessionStorage.getItem(AUTH_USER_KEY);
        if (fromSession && fromSession.length > 0) {
            localStorage.setItem(AUTH_USER_KEY, fromSession);
            sessionStorage.removeItem(AUTH_USER_KEY);
            return fromSession;
        }
    } catch (_e) {
        // private mode, blocked storage, etc.
    }
    return null;
};

export const isAuthorised = (roles) => {
    if (typeof roles === "undefined" || Array.isArray(roles) === false) {
        roles = [];
    }
    const user = getSessionData();
    if (user != null) {
        return user && user.role && roles.indexOf(user.role) >= 0;
    }
    return false;
};

export const getJwtToken = () => {
    const user = getSessionData();
    if (user != null) {
        return user.authentication.sessionToken;
    }
    return false;
};

export const destroyToken = () => {
    if (isBrowserStorageAvailable()) {
        try {
            localStorage.removeItem(AUTH_USER_KEY);
            localStorage.removeItem(AUTH_LEGACY_ID_KEY);
        } catch (_e) {
            // best-effort
        }
    }
    try {
        if (typeof window !== "undefined" && window.sessionStorage) {
            sessionStorage.removeItem(AUTH_USER_KEY);
            sessionStorage.removeItem(AUTH_LEGACY_ID_KEY);
        }
    } catch (_e) {
        // best-effort
    }
    clearForumsTracker();
};

export const setSession = (sessionData) => {
    if (!isBrowserStorageAvailable()) {
        return;
    }
    try {
        localStorage.setItem(AUTH_USER_KEY, JSON.stringify(sessionData));
        sessionStorage.removeItem(AUTH_USER_KEY);
    } catch (_e) {
        // Quota exceeded, private mode, etc.
    }
    clearForumsTracker();
};

export const getSessionData = () => {
    if (!isBrowserStorageAvailable()) {
        return null;
    }
    let userString = null;
    try {
        userString = localStorage.getItem(AUTH_USER_KEY);
        if (!userString || userString.length === 0) {
            userString = migrateSessionUserToLocal();
        }
    } catch (_e) {
        return null;
    }
    if (userString && userString.length > 0) {
        try {
            return JSON.parse(userString);
        } catch (_e) {
            return null;
        }
    }
    return null;
};
